/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StackHDownIcon16Regular = forwardRef('StackHDownIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.5.95a.55.55 0 1 0 0 1.1h5a.55.55 0 1 0 0-1.1h-5Z" }),
        React.createElement("path", { d: "M2.95 3.5a.55.55 0 0 1 .55-.55h9a.55.55 0 1 1 0 1.1h-9a.55.55 0 0 1-.55-.55Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 5A2.5 2.5 0 0 0 1 7.5v5A2.5 2.5 0 0 0 3.5 15h9a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 12.5 5h-9Zm9 1.5h-9a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Z" })));
});
